/**
 * Shared labels for the Finance module (categories, accounts, statuses).
 */
export const EXPENSE_CATEGORIES = [
  { id: "supplier_purchase", label: "Achat fournisseur", color: "#D81B8C" },
  { id: "salaries",          label: "Salaires",           color: "#6B2C8F" },
  { id: "rent",              label: "Loyer",              color: "#FF8A00" },
  { id: "transport_logistics", label: "Transport & logistique", color: "#0066B3" },
  { id: "marketing",         label: "Marketing",          color: "#3FA535" },
  { id: "other",             label: "Divers",             color: "#5C4664" },
];

export const TREASURY_ACCOUNTS = [
  { id: "cash_bureau",   label: "Cash bureau",       short: "Cash",        color: "#3FA535" },
  { id: "mobile_money",  label: "Mobile Money",      short: "MM",          color: "#E60000" },
  { id: "illicocash",    label: "Illicocash",        short: "Illico",      color: "#0066B3" },
  { id: "cb_visa",       label: "Carte bancaire",    short: "CB",          color: "#2A0E3C" },
  { id: "banque",        label: "Banque (compte)",   short: "Banque",      color: "#6B2C8F" },
];

export const EXPENSE_STATUS = {
  approved:         { label: "Approuvée",        color: "#3FA535", bg: "#E8F6E5" },
  pending_approval: { label: "En attente",       color: "#FF8A00", bg: "#FFE2D6" },
  rejected:         { label: "Rejetée",          color: "#B91C1C", bg: "#FEE2E2" },
};

export const APPROVAL_THRESHOLD = 1000;

export function categoryLabel(id) {
  return EXPENSE_CATEGORIES.find((c) => c.id === id)?.label || id;
}
export function accountLabel(id) {
  return TREASURY_ACCOUNTS.find((a) => a.id === id)?.label || id;
}
export function accountColor(id) {
  return TREASURY_ACCOUNTS.find((a) => a.id === id)?.color || "#5C4664";
}
